import {BrowserRouter as Router} from 'react-router-dom'
import {ReactKeycloakProvider} from '@react-keycloak/web'
import {ToastContainer} from "react-toastify";
import keycloak from './keycloak'
import {DiferpanRoutes} from '@routes/routes'
import {MessageProvider, QueryProvider, ThemeProvider} from '@providers'
import {ContextLoader} from '@components'
import ptBR from 'antd/lib/locale/pt_BR';
import '@styles/global.scss'

const MARGEM_RENOVACAO_TOKEN_SEGUNDOS = 30

function renovarTokenExpirado(evento: string) {
    if (evento === 'onTokenExpired') {
        keycloak.updateToken(MARGEM_RENOVACAO_TOKEN_SEGUNDOS)
    }
}

export function App() {
    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{onLoad: 'login-required', checkLoginIframe: false}}
            isLoadingCheck={keycloak => !keycloak.authenticated}
            LoadingComponent={<ContextLoader/>}
            autoRefreshToken={false}
            onEvent={renovarTokenExpirado}
        >
            <Router>
                <ThemeProvider locale={ptBR}>
                    <MessageProvider>
                        <QueryProvider>
                            <DiferpanRoutes/>
                            <ToastContainer/>
                        </QueryProvider>
                    </MessageProvider>
                </ThemeProvider>
            </Router>
        </ReactKeycloakProvider>
    )
}
